  function toggleLangMenu(e) { e.stopPropagation(); document.getElementById('profileOptions')?.classList.remove('show'); document.getElementById('langOptions').classList.toggle('show'); }
  function toggleProfileMenu(e) { e.stopPropagation(); document.getElementById('langOptions')?.classList.remove('show'); document.getElementById('profileOptions').classList.toggle('show'); }
  document.addEventListener('click', (e) => {
    var l = document.getElementById('langOptions'); var d = document.getElementById('langDropdown'); if(l && d && !d.contains(e.target)) l.classList.remove('show');
    var p = document.getElementById('profileOptions'); if(p && !document.querySelector('.profile-menu-wrapper').contains(e.target)) p.classList.remove('show');
  });

  function __floramePushMenuButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-florame-push-menu-toggle]'));
  }

  function __floramePushMenuLabel(state, opts) {
    if (opts && opts.busy) return 'Aggiorno...';
    if (opts && opts.error) return String(opts.error || 'Errore notifiche').slice(0, 64);
    if (!state || state.supported === false) return 'Non supportate';
    if (state.permission === 'denied') return 'Permesso bloccato';
    if (state.platform === 'ios' && !state.standalone && !state.subscribed) return 'Apri da Home';
    return state.subscribed ? 'Attive' : 'Spente';
  }

  function __florameSetPushMenuState(state, opts) {
    var next = state || {};
    var label = __floramePushMenuLabel(next, opts || {});
    __floramePushMenuButtons().forEach(function(button) {
      var enabled = !!next.subscribed;
      button.classList.toggle('is-on', enabled);
      button.classList.toggle('is-error', !!(opts && opts.error) || next.permission === 'denied' || next.supported === false);
      button.classList.toggle('is-busy', !!(opts && opts.busy));
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
      if (next.supported === false) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
      var status = button.querySelector('[data-florame-push-menu-status]');
      if (status) status.textContent = label;
    });
  }

  function syncFloramePushMenu(attempt) {
    var api = window.FlorameWebPush;
    if (!api || typeof api.status !== 'function') {
      if ((attempt || 0) < 20) {
        window.setTimeout(function() { syncFloramePushMenu((attempt || 0) + 1); }, 150);
        return;
      }
      __florameSetPushMenuState({ supported: false }, { error: 'Non disponibile' });
      return;
    }
    __florameSetPushMenuState({ supported: true }, { busy: true });
    api.status()
      .then(function(state) { __florameSetPushMenuState(state || {}); })
      .catch(function(error) {
        __florameSetPushMenuState({ supported: true }, { error: error && error.message ? error.message : 'Errore notifiche' });
      });
  }

  function toggleFloramePushFromMenu(event) {
    try { event.preventDefault(); event.stopPropagation(); } catch (_) {}
    var button = event && event.currentTarget ? event.currentTarget : document.querySelector('[data-florame-push-menu-toggle]');
    if (!button || button.classList.contains('is-busy')) return;
    if (button.getAttribute('aria-disabled') === 'true') return;
    var api = window.FlorameWebPush;
    if (!api || typeof api.setEnabled !== 'function') {
      __florameSetPushMenuState({ supported: false }, { error: 'Non disponibile' });
      return;
    }
    var targetEnabled = !button.classList.contains('is-on');
    __florameSetPushMenuState({ supported: true, subscribed: !targetEnabled }, { busy: true });
    api.setEnabled(targetEnabled)
      .then(function(state) { __florameSetPushMenuState(state || { supported: true, subscribed: targetEnabled }); })
      .catch(function(error) {
        var message = error && error.message ? error.message : 'Errore notifiche';
        if (typeof api.status === 'function') {
          api.status()
            .then(function(state) { __florameSetPushMenuState(state || {}, { error: message }); })
            .catch(function() { __florameSetPushMenuState({ supported: true, subscribed: !targetEnabled }, { error: message }); });
          return;
        }
        __florameSetPushMenuState({ supported: true, subscribed: !targetEnabled }, { error: message });
      });
  }

  window.toggleFloramePushFromMenu = toggleFloramePushFromMenu;
  document.addEventListener('DOMContentLoaded', function() { syncFloramePushMenu(); });
  window.addEventListener('pageshow', function() { syncFloramePushMenu(); });
  window.addEventListener('florame:web-push-state', function(event) {
    __florameSetPushMenuState(event && event.detail ? event.detail : {});
  });

  function selectLang(lang, em) {
    var clean = String(lang || '').includes('en') ? 'en' : 'it';
    if (window.FlorameI18n && typeof window.FlorameI18n.setLanguage === 'function') {
      window.FlorameI18n.setLanguage(clean);
    } else {
      try { localStorage.setItem('florame_native_lang', clean); localStorage.setItem('bouquetLanguage', clean); } catch (_) {}
      try { document.documentElement.setAttribute('lang', clean); } catch (_) {}
    }
    document.querySelectorAll('#langDropdown [data-lang]').forEach(function(button) {
      button.classList.toggle('is-active', button.getAttribute('data-lang') === clean);
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    var lang = 'it';
    try { lang = localStorage.getItem('florame_native_lang') || document.documentElement.getAttribute('lang') || 'it'; } catch (_) {}
    document.querySelectorAll('#langDropdown [data-lang]').forEach(function(button) {
      button.classList.toggle('is-active', button.getAttribute('data-lang') === String(lang).slice(0, 2));
    });
  });

  window.addEventListener('florame:native-language-change', function(event) {
    var lang = event?.detail?.language || 'it';
    document.querySelectorAll('#langDropdown [data-lang]').forEach(function(button) {
      button.classList.toggle('is-active', button.getAttribute('data-lang') === lang);
    });
  });
